import { createLogger, VueLogger, type LogLevel } from 'vue-logger-plugin'
import { defineStore } from 'pinia'

console.log(import.meta.env.MODE, import.meta.env.VITE_ASCEND_VERSION_NUMBER, import.meta.env.VITE_ASCEND_BUILD_TIMESTAMP);

let loggerLevel: LogLevel = 'debug'
if (import.meta.env.MODE === 'production') {
  loggerLevel = 'error'
}
// create logger with options
const logger = createLogger({
  enabled: true,
  level: loggerLevel,
  callerInfo: true,
})

export default logger

export function useStoreLogger(): VueLogger {
  const storeLogger = loggerStore().logger
  return storeLogger ?? logger
}

export function setStoreLogger(logger: VueLogger) {
  loggerStore().logger = logger
}

const loggerStore = defineStore('logger', () => {
  const logger = null as VueLogger | null
  return { logger }
})
